import { Configuration, PublicClientApplication } from "@azure/msal-browser";

const tenantId = import.meta.env.VITE_MSAL_TENANT_ID;
const clientId = import.meta.env.VITE_MSAL_CLIENT_ID;
const authEndpoint = import.meta.env.VITE_MSAL_AUTH_ENDPOINT_V2;
const redirectUri = import.meta.env.VITE_MSAL_REDIRECT_URI;

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: authEndpoint,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowPlatformBroker: false, // Disables WAM Broker
  },
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize();

export const getToken = async () => {
  const account = msalInstance.getAccount({
    tenantId,
  });
  if (!account) {
    return null;
  }
  const token = await msalInstance.acquireTokenSilent({
    scopes: ["User.Read"],
    account,
  });
  return token.idToken;
};
